"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CART_STATUS = void 0;
exports.CART_STATUS = {
    NEW: 'NEW',
    CONVERTED: 'CONVERTED',
    ABANDONED: 'ABANDONED',
    DECLINED: 'DECLINED'
};
//# sourceMappingURL=cartStatus.js.map